'use client';

import { createContext, use, type ReactNode } from 'react';

interface HandsFreePopupSelectionContextValue {
  value: string;
  onChange: (value: string) => void;
}

const HandsFreePopupSelectionContext =
  createContext<HandsFreePopupSelectionContextValue | null>(null);

interface Props {
  value?: string;
  onChange?: (value: string) => void;
  children: ReactNode;
}

export function HandsFreePopupSelectionProvider({
  value,
  onChange,
  children,
}: Props) {
  const selection =
    value !== undefined && onChange !== undefined ? { value, onChange } : null;

  return (
    <HandsFreePopupSelectionContext value={selection}>
      {children}
    </HandsFreePopupSelectionContext>
  );
}

export function useHandsFreePopupSelection() {
  return use(HandsFreePopupSelectionContext);
}
